export default __webpack_public_path__ + "28fdb2a38087d31b996ca3594bfab121.png";